/* Reglas de texto, fase 1 (25-oct-2026): lo que necesita medir la página; el resto está en hai-texto.css.
   1. Lugares fijos por fila (regla 5): cada nombre de tarjeta ocupa lo mismo que el más largo de su fila (dos
      líneas como máximo, por el corte de hai-texto.css). Así la línea de datos y la descripción parten a la
      misma altura en todas, sin reservar una segunda línea en las filas donde todos los nombres caben en una.
   2. En escritorio, el título de un carrusel arranca donde arranca su primera tarjeta (en la home las cuatro
      fórmulas van centradas y empiezan en 184 px, y su título quedaba suelto en el borde de la página).
   Se recalcula al cambiar el ancho, al cambiar de pestaña y cuando llegan tarjetas tarde (recomendados,
   vistos recientemente, «Cargar más», filtros). Sin este script la página funciona igual: solo vuelve el desfase. */
(() => {
  function igualarFilas() {
    const nombres = [...document.querySelectorAll('.card__content .card__title-text')];
    nombres.forEach((n) => n.style.removeProperty('min-height'));
    const filas = new Map();
    for (const n of nombres) {
      const tarjeta = n.closest('.card-container') || n.closest('.card');
      const r = tarjeta && tarjeta.getBoundingClientRect();
      if (!r || !r.width) continue;
      const seccion = tarjeta.closest('[id^="shopify-section-"]');
      const clave = (seccion ? seccion.id : '') + '@' + Math.round(r.top + scrollY);
      if (!filas.has(clave)) filas.set(clave, []);
      filas.get(clave).push(n);
    }
    // Primero se leen TODAS las filas y después se escribe: leer una medida justo después de escribir un alto
    // obliga al navegador a recalcular la página entera, y fila por fila eran 10 a 20 recálculos en el inicio
    // (medido el 25-oct con la CPU × 4: 0,12 a 0,37 s de este script en la carga).
    const medidas = [];
    for (const fila of filas.values()) {
      if (fila.length < 2) continue;
      medidas.push([fila, Math.max(...fila.map((n) => n.getBoundingClientRect().height))]);
    }
    for (const [fila, alto] of medidas) fila.forEach((n) => n.style.setProperty('min-height', alto + 'px'));
  }

  function titulosConSuContenido() {
    const cabeceras = [...document.querySelectorAll('.slider__header')];
    cabeceras.forEach((h) => h.style.removeProperty('padding-left'));
    if (innerWidth < 750) return;
    // Lo mismo: todas las lecturas antes de la primera escritura.
    const corridas = cabeceras.map((h) => {
      const raiz = h.closest('.shopify-section') || h.parentElement;
      const primera = raiz && raiz.querySelector('.slider__grid > *');
      return [h, primera ? primera.getBoundingClientRect().left - h.getBoundingClientRect().left : 0];
    });
    corridas.forEach(([h, dx]) => { if (dx > 8) h.style.setProperty('padding-left', Math.round(dx) + 'px', 'important'); });
  }

  let espera;
  const programar = () => {
    clearTimeout(espera);
    espera = setTimeout(() => { titulosConSuContenido(); igualarFilas(); }, 120);
  };
  const traeTarjetas = (n) => n.nodeType === 1 && (n.matches('.card__content, .card-container, .card') || !!n.querySelector('.card__content'));

  // Solo cuando cambia el ANCHO: en el teléfono el alto cambia al desplazar (la barra de direcciones se esconde y
  // vuelve) y cada cambio recalculaba las filas en pleno desplazamiento.
  let anchoPrevio = innerWidth;
  addEventListener('resize', () => { if (innerWidth !== anchoPrevio) { anchoPrevio = innerWidth; programar(); } });
  addEventListener('load', programar);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(programar);
  document.addEventListener('click', (e) => { if (e.target.closest('.component-tabs__tab')) setTimeout(programar, 350); });
  new MutationObserver((cambios) => {
    if (cambios.some((c) => [...c.addedNodes].some(traeTarjetas))) programar();
  }).observe(document.body, { childList: true, subtree: true });
  programar();
})();
